<template>
    <div>
        <h4 class="is-size-4">Contenido</h4>
        <ol>
            <li class="is-size-5">
                <a href="/sepomex/paises/#paises">Paises</a>
            </li>
            <li class="is-size-5">
                <a href="/sepomex/paises/#pais">Pais</a>
            </li>
        </ol>
        <br>

        <h3 class="is-size-4" id="paises">1.- Paises</h3>
        <strong>Enpoint con la lista de paises, siempre regresa un array de objetos, incluso aunque sea solo un elemento</strong>
        <br><br>
        <p>
            <code>GET {{ host }}/api/sepomex/paises</code>
        </p>

        <h5 class="is-size-6">Parametros opcionales para busqueda:</h5> 
        <div class="content">
            <ul>
                <li>
                    <strong>id</strong>
                    <ul>
                        <li>Opcional</li>
                        <li>Formato string (Ej. 'MEX')</li>
                    </ul>
                </li>
                <li>
                    <strong>countryCode</strong>
                    <ul>
                        <li>Opcional</li>
                        <li>Formato string (Ej. 'MEX')</li>
                    </ul>
                </li>
                <li>
                    <strong>countryName</strong>
                    <ul>
                        <li>Opcional</li>
                        <li>Formato string (Ej. 'Alemania')</li>
                    </ul>
                </li>
            </ul>
        </div>

        <h5 class="is-size-6 has-text-weight-bold">Respuesta de Ejemplo:</h5>
        <pre>
            <h5 class="has-text-link">GET {{ host }}/api/sepomex/paises</h5>
            <code>[
                {
                    "id": "CRI",
                    "countryCode": "CRI",
                    "countryName": "Costa Rica"
                },
                {
                    "id": "CUB",
                    "countryCode": "CUB",
                    "countryName": "Cuba"
                },
                {
                    "id": "CHL",
                    "countryCode": "CHL",
                    "countryName": "Chile"
                }
                ...
            ]</code>
        </pre>
        <hr />

        <h3 class="is-size-3" id="pais">2.- Pais</h3>
        <strong>Enpoint con el detalle de un solo pais, siempre regresa un objeto.</strong>
        <br><br>
        <p>
            <code>GET {{ host }}/api/sepomex/pais/{id}</code>
        </p>

        <h5 class="is-size-6">Parametros:</h5> 
        <div class="content">
            <ul>
                <li>
                    <strong>id</strong>
                    <ul>
                        <li>Requerido</li>
                        <li>Formato string (Ej. 'MEX')</li>
                    </ul>
                </li>
            </ul>
        </div>

        <h5 class="is-size-6 has-text-weight-bold">Respuesta de Ejemplo:</h5>
        <pre>
            <h5 class="has-text-link">GET {{ host }}/api/sepomex/pais/MEX</h5>
            <code>{
                "id": "MEX",
                "countryCode": "MEX",
                "countryName": "México"
            }</code>
        </pre>
    </div>
</template>

<script>
export default {
    name: 'SepomexPaises',
    data () {
        return {
            host: process.env.VUE_APP_HOST
        }
    }
}
</script>

<style scoped>
p {
    margin-bottom: 15px;
}
</style>
